import { inject as service } from '@ember/service';
import Route from '@ember/routing/route';

export default class PrivacyPolicyRoute extends Route {
  @service router;
  @service fastboot;

  beforeModel() {
    if (this.fastboot?.isFastBoot) {
      let response = this.fastboot.response;
      response.statusCode = 301;
      response.headers.set('Location', '/privacy');
    } else {
      this.router.replaceWith('privacy');
    }
  }
}
